import * as React from 'react';

export function Spinner() {
  return (
    <div className="divProcessingSpinner">
      <div className="spinner">
        <span>|</span><span>|</span><span>|</span><span>|</span><span>|</span><span>|</span><span>|</span><span>|</span>
      </div>
      <p id="divProcessingSpinner-message"><span tabIndex={-1}>Processing. Please Wait.</span></p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/spinner.tsx